// Supported UI languages and URL helpers for language-prefixed routes.
// English content lives at the site root (/map); every other language is
// served under its own prefix (/es/map, /zh-CN/map, ...). Search engines can
// only index languages that have distinct URLs, which is why the prefix -
// not localStorage - is the source of truth for the active language.

export const SUPPORTED_LANGUAGES = ['en', 'ua', 'es', 'de', 'fr', 'zh-CN', 'ja'];
export const DEFAULT_LANGUAGE = 'en';
export const PREFIXED_LANGUAGES = SUPPORTED_LANGUAGES.filter((lng) => lng !== DEFAULT_LANGUAGE);

// BCP-47 values for <html lang>
export const HTML_LANG = {
  en: 'en',
  ua: 'uk',
  es: 'es',
  de: 'de',
  fr: 'fr',
  'zh-CN': 'zh-CN',
  ja: 'ja',
};

// Open Graph locale codes per language
export const OG_LOCALE = {
  en: 'en_US',
  ua: 'uk_UA',
  es: 'es_ES',
  de: 'de_DE',
  fr: 'fr_FR',
  'zh-CN': 'zh_CN',
  ja: 'ja_JP',
};

export const isSupportedLanguage = (lng) => SUPPORTED_LANGUAGES.includes(lng);

// '/es/map' -> 'es', '/map' -> null
export const getLanguageFromPath = (pathname) => {
  const seg = (pathname || '').split('/')[1];
  return isSupportedLanguage(seg) ? seg : null;
};

// '/es/map' -> '/map', '/map' -> '/map'
export const stripLanguagePrefix = (pathname) => {
  const lang = getLanguageFromPath(pathname);
  if (!lang) return pathname || '/';
  return pathname.substring(lang.length + 1) || '/';
};

// localizePath('/map', 'es') -> '/es/map'; localizePath('/es/map', 'en') -> '/map'
export const localizePath = (pathname, lng) => {
  const bare = stripLanguagePrefix(pathname);
  return lng === DEFAULT_LANGUAGE ? bare : `/${lng}${bare === '/' ? '' : bare}`;
};

// One-shot intent set when the user explicitly switches to the default
// language (whose URLs carry no prefix). It tells LanguageSync not to
// interpret the unprefixed URL as "keep the previous language".
let languageIntent = null;
export const setLanguageIntent = (lng) => {
  languageIntent = lng;
};
export const consumeLanguageIntent = () => {
  const value = languageIntent;
  languageIntent = null;
  return value;
};
